export default {
  text1: 'Benefícios:',
  text2: 'Sobre SIS',
  text3:
    'SIS Consultoría está estructurada para suministrar, con alta performance y compromiso, servicios de tecnología de la información y consultoría de negocios para el mundo corporativo. Nuestra promesa es garantizar que atenderemos todos los desafíos, proporcionando el más alto nivel de satisfacción para nuestros clientes, colaboradores y la comunidad.',
  text4:
    'Nuestras inversiones tanto en el cuerpo estratégico y gerencial  como en los equipos multidisciplinarios son constantes, contemplando siempre aspectos de negocios, técnicos y conductuales. A cada desafío, aplicamos sólidos conocimientos en gestión, desarrollo, metodologías ágiles y herramientas de gobernanza a favor de nuestros clientes.',
}
